module.exports = __webpack_public_path__ + "img/img-11.73d90760.png";